import { Component } from '@angular/core';

@Component({
  selector: 'app-pago-rechazado',
  standalone: false,
  templateUrl: './pago-rechazado.component.html',
  styleUrl: './pago-rechazado.component.scss'
})
export class PagoRechazadoComponent {


  intentarDeNuevo(): void {

  }
}
